import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
  delay,
} from "redux-saga/effects";

import {
  EXTEND_FREE_LICENSE,
  CLEAR_ALL_FREE_LICENSE_MESSAGES,
} from "./actionTypes";
import { extendFreeLicenseSuccessful, extendFreeLicenseFailed, clearAllFreeLicenseMessagesSuccessful as clearAllFreeLicenseMessagesSuccessfulAction, clearAllFreeLicenseMessagesSuccessful } from './actions';
import { extendFreeLicense as extendFreeLicenseApi } from '../../helpers/auth_helper';

import { EncryptMessage } from "../../../src/components/EncryptPassword";

function* extendFreeLicense({ payload: { extendLicenseData } }) {
  try {
    const response = yield call(extendFreeLicenseApi, {
      days: parseInt(extendLicenseData.days), 
      orgCode: EncryptMessage(extendLicenseData.orgCode),
    });
    console.log("extendFreeLicense response: ", response);

      if(response.status === 200){
        delete response.status;
        let responseMessage = Object.values(response).join('');
        yield put(extendFreeLicenseSuccessful({message: responseMessage}));
      } else {
          // console.log(" response in else part, ", JSON.stringify(response));
          let message;
          if(response.data?.message) {
              message = response.data.message;
          } else {
              message = response.data;
          }
          yield put(extendFreeLicenseFailed({message: message}));
      }
  } catch (error) {
      console.log("extendFreeLicense error: ", error);
      if (error.response){
          console.log("extendFreeLicense, error.response", error.response);
          let message;
          if(error.response?.data?.message) {
            message = error.response?.data?.message;
          } else {
            message = error.response?.data;
          }
          yield put(extendFreeLicenseFailed({message: message}));
      } else if (error.request){
        console.log("extendFreeLicense, error.request", error.request);
          yield put(extendFreeLicenseFailed({message: JSON.stringify(error.request)}));
      } else {
        console.log("extendFreeLicense, error.message", error.message);
          yield put(extendFreeLicenseFailed({message: error.message}));
      }
  }
}


export function* clearAllFreeLicenseMessages() {
  console.log("Saga: clear all free license messages");
  yield put(clearAllFreeLicenseMessagesSuccessfulAction());
}


export function* watchFreeLicense() {
  yield takeLatest(EXTEND_FREE_LICENSE, extendFreeLicense);
  yield takeLatest(CLEAR_ALL_FREE_LICENSE_MESSAGES, clearAllFreeLicenseMessages);
}

function* freeLicenseSaga() {
  yield all([fork(watchFreeLicense)]);
}

export default freeLicenseSaga;

